
import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Location } from '@angular/common';
import { ToasterComponent } from '../toasterComponent/toasterComponent';
import { HttpClientCustom } from '../shared/services/http.client';
import { Configuration } from '../shared/services/configuration';
import { SharedData } from '../shared/sharedData';
import * as FileSaver from 'file-saver';
import { Headers } from '@angular/http/src/headers';
import { HttpResponse, HttpHeaders } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { Options } from 'selenium-webdriver/ie';
import { ConfirmationComponent } from 'app/confirmation/confirmation';

@Component({
  selector: 'bulkResign',
  templateUrl: './bulkResign.component.html'
})
export class BulkResignComponent {

  public attachmentFile: any;
  public fileNameToUpload: any = null;
  public _baseUrl: any;
  public fileType: any = false;
  public comments: any = '';
  public uploadButtonDisable: any = false;
  public page = 1;
  public pageSize: any = 10;
  public allData: any = [];
  public allPageData: any = [];
  public collectionSize: any;
  public endingPage: any = 10;
  public showGrid: any = false;
  public selectedProcess: any = 'Select';
  public startingPage: any = 1;
  public fileExtension: any;
  public trackHides = null;

  constructor(
    public route: ActivatedRoute,
    public share: SharedData,
    public modalService: NgbModal,
    public activeModal: NgbActiveModal,
    public _location: Location,
    public _toast: ToasterComponent,
    public viewContainerRef: ViewContainerRef,
    public _http: HttpClientCustom,
    public _global: Configuration,
    public translate: TranslateService,
    public _share: SharedData) {
      this._baseUrl = _global.get('EPMS_BASE_URL');
      this.getAll();
      
    }

 

    public chooseFile(event) {
      if (event.target.files && event.target.files.length > 0) {
        let self = this;
        self.attachmentFile = event.target.files[0];
        self.fileNameToUpload = event.target.files[0].name;
        event.srcElement.value = null;
      }
    }

    public downloadKpiTemplate() {
      try {
        let url = this._baseUrl + 'v1/webAdmin/employee/downloadEmpResignTemplate/'
           + this.fileType;
        this._http.getBlob(url).subscribe((result: HttpResponse<Blob>) => {
          let name = this.getFileNameFromHeader(result.headers);
          FileSaver.saveAs(result.body, name);
        });
      } catch (e) {
        console.log('download error caught', e);
      }
    }

    public downloadTemplate() {
      this.downloadKpiTemplate();
    }
    public onFileTypeChange(event) {
      if (event === 'xlsx' || event === 'XLSX') {
        this.fileType = false;
      } else {
        this.fileType = true;
      }
    }

    public getFileNameFromHeader(headers: HttpHeaders): string {
      let header = headers.get('Content-Disposition');
      if (header == null) {
        return 'test.xlxs';
      } else {
        if (!header) {
          return null;
        }
        let result: string = header.split(';')[1].trim().split('=')[1];
        return result.replace(/'/g, '');
      }
    }
    public uploadFile() {
      this.actionResign();
    }
   

    public uploadAllTemplate(booleanValue) {
      if (this.validate()) {
        this.uploadButtonDisable = true;
        let formData: FormData = new FormData();
        formData.append('file', this.attachmentFile);
        formData.append('comment', this.comments);
        formData.append('forceResign',booleanValue);
        let url = this._baseUrl + 'v1/webAdmin/employee/uploadEmpResign/';
        {}
        let  options = {responseType : 'text'};
        this._http.filePost(url, formData,options).subscribe((res) => {
          
         
         if(res != null){
          this.translate.get('fileUpdatedSuccessfully').subscribe((msg)=>{
            this._toast.showSuccess(msg);
          });
          this.getAll();
          this.fileNameToUpload = null;
          this.comments = '';
          this.selectedProcess = 'Select';
          this.uploadButtonDisable = false;
         }else{
          this.translate.get('fileUploadFailed').subscribe((msg)=>{
            this._toast.showError(msg);
          });
          this.getAll();
          this.fileNameToUpload = null;
          this.comments = '';
          this.selectedProcess = 'Select';
          this.uploadButtonDisable = false;
         }
         
        }, (error) => {
          this.translate.get('fileUpdateFailed').subscribe((msg)=>{
            this._toast.showError(msg);
            this.uploadButtonDisable = false;
          });
          
        });
      }
    }
    public validate() {
      if (this.comments.trim() === '') {
        this.translate.get('commentsMandatory').subscribe((msg)=>{
          this._toast.showError(msg);
        });
        return false;
      } else {
        return true;
      }
    }

    public getAll() {
      let self = this;
      let url = self._baseUrl + 'v1/webAdmin/uploadProcess/getAllByGroup?group=EMP_RESIGN'
        + '&page=' + self.page + '&pageSize=' + self.pageSize;
      self._http.get(url).subscribe((result) => {
        self.allData = result.content;
        self.allPageData = result;
        self.collectionSize = result.totalElements;
        if (self.collectionSize < self.pageSize) {
          self.endingPage = self.collectionSize;
        }
        self.showGrid = true;
      }, (error) => {
        console.log(error);
      });
    }
    public OnPageSizeChanged(val) {
      this.pageSize = val;
      this.getAll();
    }

    public onPageChange(event: number): void {
      if (event === 1) {
        this.startingPage = 1;
        this.endingPage = 10;
      } else {
        this.startingPage = 1 + this.pageSize;
        if (this.collectionSize > this.endingPage) {
          this.endingPage = event + this.endingPage;
        } else {
          this.endingPage = this.collectionSize;
        }
      }
      this.page = event;
      this.getAll();
    }
    public onProcessChange() {
      this.fileNameToUpload = null;
  
    }


    public getDateFormat(date) {
      let dateCreated = new Date(date);
      return dateCreated.toString().substring(4, 15);
    }
  
     public getExtension(fileName){
      this.fileExtension = fileName.split('.').pop();
      return this.fileExtension.toLowerCase();
    }
  
    public downloadValidationFile(path) {
      let self = this;
      let url = self._baseUrl + 'v1/webAdmin/uploadProcess/downloadFile/' + path;
      this._http.getBlob(url).subscribe((result: HttpResponse<Blob>) => {
        let name = this.getFileNameFromHeader(result.headers);
        FileSaver.saveAs(result.body, name);
      }, (error) => {
        console.log(error);
      });
    }


    public actionResign() {
      let closeResult: any;
      this.trackHides = null;
      let confirmData: any = {
          type: 'Bulk_Resign'
      };
      this.share.saveData(confirmData);
      const modalRef = this.modalService.open(ConfirmationComponent,
          { windowClass: 'min-modal' }).result.then((result) => {
              closeResult = `Closed with: ${result}`;
              if (result === 'forceResign') {

                this.uploadAllTemplate(true);
                 
              } else {
                this.uploadAllTemplate(false);
              }
          }, (reason) => {
              closeResult = `Dismissed`;
          });
  }
  
}



// WEBPACK FOOTER //
// ./src/app/bulkResign/bulkResign.component.ts